export const languages = [
  {label: 'English', value: 'en'},
  {label: 'Espanol', value: 'es'},
  {label: 'Portuguese', value: 'pt'},
];
